module.exports = __webpack_public_path__ + "media/customizations/regencyatsrr/back-383b5d573e73cd63876bf1574c644100.jpg";